import { SegmentedControlOption } from "@/components/toggle/segmented-control";

export type SavedMealsTabValue = "your-food" | "most-used";

export const resolveSavedMealsTab = (value: string | null): SavedMealsTabValue =>
  value === "most-used" ? "most-used" : "your-food";

export const SAVED_MEALS_TAB_OPTIONS: SegmentedControlOption[] = [
  {
    value: "your-food",
    label: "Recent",
    classNames: {
      button: "bg-white text-your-foods",
      buttonActive: "bg-your-foods text-white",
    },
  },
  {
    value: "most-used",
    label: "Most used",
    classNames: {
      button: "bg-white text-screen-gs-1",
      buttonActive: "bg-screen-gs-1 text-white",
    },
  },
];
